import { c as _c } from "react/compiler-runtime";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import cx from 'classnames';
import { alpha } from '@classify/react-core-components/styles';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(({
  palette,
  typography,
  spacing,
  shape,
  breakpoints
}) => {
  const lineColor = alpha(palette.layout.line.divider, 0.6);
  return {
    root: {
      position: 'relative',
      width: '100%',
      display: 'grid',
      textDecoration: 'none',
      gridTemplateColumns: 'min-content 1fr min-content',
      alignItems: 'stretch',
      '& > *': {
        display: 'flex',
        alignItems: 'center'
      }
    },
    decoration: {
      position: 'relative',
      borderTopLeftRadius: shape.borderRadius,
      borderBottomLeftRadius: shape.borderRadius
    },
    content: {
      border: `1px solid ${lineColor}`,
      borderTopLeftRadius: shape.borderRadius,
      borderBottomLeftRadius: shape.borderRadius,
      borderRight: 'none',
      flexGrow: '1',
      padding: spacing(1, 2),
      ...typography.subtitle1
    },
    iconContainer: {
      border: `1px solid ${lineColor}`,
      borderLeft: 'none',
      borderTopRightRadius: shape.borderRadius,
      borderBottomRightRadius: shape.borderRadius,
      paddingRight: spacing(1)
    },
    icon: {
      fontSize: '1.7rem',
      color: palette.text.secondary
    },
    isColorDimmed: {
      '& $decoration': {
        '&::before': {
          background: ['rgba(255, 255, 255, .93)', '!important']
        }
      }
    },
    hasDecoration: {
      '& $content': {
        borderLeft: 'none'
      },
      '& $decoration': {
        minWidth: 8,
        background: 'var(--color)',
        '& > *': {
          zIndex: 1,
          position: 'relative'
        },
        '&::before': {
          content: '" "',
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          background: 'rgba(255, 255, 255, .68)'
        }
      }
    },
    [breakpoints.up('sm')]: {
      decoration: {
        '& > *': {
          display: 'block'
        }
      }
    }
  };
});
export default function CardLink(t0) {
  const $ = _c(36);
  let children;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      children,
      color: t1,
      component: t2,
      decoration: t3,
      isColorDimmed: t4,
      ariaLabel: t5,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    children = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  const color = t1 === undefined ? "transparent" : t1;
  const Component = t2 === undefined ? "a" : t2;
  const decoration = t3 === undefined ? null : t3;
  const isColorDimmed = t4 === undefined ? false : t4;
  const ariaLabel = t5 === undefined ? "Go to" : t5;
  const classes = useStyles();
  let t6;
  if ($[8] !== classes.hasDecoration || $[9] !== classes.isColorDimmed || $[10] !== classes.root || $[11] !== decoration || $[12] !== isColorDimmed) {
    t6 = cx(classes.root, {
      [classes.isColorDimmed]: isColorDimmed,
      [classes.hasDecoration]: decoration
    });
    $[8] = classes.hasDecoration;
    $[9] = classes.isColorDimmed;
    $[10] = classes.root;
    $[11] = decoration;
    $[12] = isColorDimmed;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== color) {
    t7 = {
      "--color": color
    };
    $[14] = color;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== classes.decoration || $[17] !== decoration) {
    t8 = <div className={classes.decoration}>{decoration}</div>;
    $[16] = classes.decoration;
    $[17] = decoration;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== children || $[20] !== classes.content) {
    t9 = <div className={classes.content}>{children}</div>;
    $[19] = children;
    $[20] = classes.content;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== ariaLabel || $[23] !== classes.icon) {
    t10 = <ChevronRightIcon className={classes.icon} aria-label={ariaLabel} />;
    $[22] = ariaLabel;
    $[23] = classes.icon;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== classes.iconContainer || $[26] !== t10) {
    t11 = <div className={classes.iconContainer}>{t10}</div>;
    $[25] = classes.iconContainer;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== Component || $[29] !== otherProps || $[30] !== t11 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t12 = <Component {...otherProps} className={t6} style={t7}>{t8}{t9}{t11}</Component>;
    $[28] = Component;
    $[29] = otherProps;
    $[30] = t11;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}